import React, { useState, useEffect } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import UpdateServiceCharge from "./ServiceChargePopUp/ServiceChargePopUp";
import { RiSearch2Line } from "react-icons/ri";

export default function ListServiceChargeEdit({
  titles = [],
  list = [],
  callBack,
}) {
  const dispatch = useDispatch();
  const [Popup, setPopUp] = useState(false);
  const [empId, setEmpId] = useState();
  const [searchWords, setSearchWords] = useState([]);
  const [search, setSearch] = useState([]);

  const setEmp = (empId) => {
    setEmpId(empId);
    setPopUp(true);
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const apiCall = () => {
    callBack(`/service-charge-edit?keyword=${search}`);
  };
  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <div className={`max-w-fit w-full flex  items-center relative my-1`}>
            <RiSearch2Line className="absolute mx-1 text-slate-400" />
            <input
              type="search"
              className={`input input-sm h-10 max-w-xs pl-6 w-full input-bordered focus:outline-none uppercase`}
              placeholder={"enter search emp id"}
              onChange={(e) => {
                var dataValue = e.target.value;
                setSearch(e.target.value);
                callBack(dataValue);
                //
                // console.log(dataValue);
                // if (e.target.value.length >= 3) {

                // }
              }}
            />
          </div>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[1450px]">
              <div className="grid grid-cols-table-service gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-service gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {!list?.isLoading && <NoDataFound />}
              {!list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.quotation_type || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.arrival_date || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.contract_end_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.contract_tenure || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.arrival_date || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.border_number || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_expiry_date_g || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.actual_profession || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_profession || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.profession_level || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.service_charge.toString() || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.new_service_charge || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.new_service_charge_date || "-"}
                      />
                    </p>

                    <button
                      className={
                        "p-1 px-2 rounded-md  bg-green-500 text-white text-xs p-2 w-20"
                      }
                      onClick={() => {
                        setEmp(list.employee_id);
                      }}
                    >
                      Update
                    </button>
                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
        <Pagination />

        {Popup ? (
          <UpdateServiceCharge
            list={empId}
            PopUp={Popup}
            setPopUp={setPopUp}
            title={"Service Charge"}
            url={"/service-charge-edit/update"}
            callBack={apiCall}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
